import React, { useEffect, useState } from "react";
import MainComponent from "../MainComponent";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Objective from "../../assets/images/Objective.svg";
import Goals from "../../assets/images/Goals.svg";
import Up from "../../assets/images/up.svg";
import Down from "../../assets/images/down.svg";
import ChevronLeft from "../../assets/images/Chevron-left.svg";
import ChevronRight from "../../assets/images/Chevron-right.svg";
import GoalSelector from "./GoalSelector";
import FunctionalGoalMeeting from "./FunctionalGoalMeeting";
import { BiChevronDown } from "react-icons/bi";
import keys from "../../utils/helpInfoKeys.json";
import { TiDelete } from "react-icons/ti";
import {
  getAiMeetingInsights,
  getBiFGoalStatus,
  getFunctionalGoalReviewMeetingData,
  getInitiativeTrackerDetails,
} from "../../store/actions";
import { url } from "../../store/sagas/API.js";

import {
  getRandomColor,
  createImageFromInitials,
  createProgressBar,
  createStatus,
} from "../Utils";
import UserProfile from "../../assets/images/user-profile.svg";

import "./XLExecutionPlan.css";
import "./InitiativeTracker.css";
import CommentSection from "../../utils/CommentSection.js";
import Login from "../Login.js";
import SideNavHelpInfo from "../../utils/SideNavHelpInfo.js";
import { AnimatePresence, motion } from "motion/react";
import { OverlayTrigger, ProgressBar, Tooltip } from "react-bootstrap";
import { HiSparkles } from "react-icons/hi2";
import { Drawer } from "@mui/material";

function InitiativeTracker() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedHelpInfoSidebar = useSelector(
    (state) => state.selectedHelpInfoSidebar
  );
  const selectedSubMenuPermission = useSelector(
    (state) => state.selectedSubMenuPermission
  );
  const [selectedFunction, setSelectedFunction] = useState(null);
  const [objectiveList, setObjectiveList] = useState([]);
  const [goalList, setGoalList] = useState([]);
  const [functionList, setFunctionList] = useState([]);
  const [momentumScore, setMomentumScore] = useState(0);
  const selectedBI = useSelector((state) => state.selectedBI);
  const [showMeetingPopup, setShowMeetingPopup] = useState(false);
  const [singleGoal, setSingleGoal] = useState(false);
  const [status, setStatus] = useState("");
  const getInitTrackerDetails = useSelector(
    (state) => state.getInitTrackerDetails
  );
  const [biName, setBIName] = useState(null);
  const fetchGetBiFStatusData = useSelector(
    (state) => state.fetchGetBiFStatusData
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage, setCardsPerPage] = useState(4);
  const [showSummary, setShowSummary] = useState(false);
  const [aiButtonEnabled, setAiButtonEnabled] = useState(false);

  const fetchgetChatbot = useSelector((state) => state.fetchgetChatbot);
  const aiMeetingInsights = useSelector((state) => state.fetchGetAiMeetingInsights);
  
  useEffect(() => {
    if (fetchGetBiFStatusData && fetchGetBiFStatusData.data) {
      const data = fetchGetBiFStatusData.data[0]?.value;
      setStatus(data);
    }
  }, [fetchGetBiFStatusData]);
  useEffect(() => {
    if (localStorage.getItem("bi_id") && localStorage.getItem("product_id")) {
      dispatch(
        getInitiativeTrackerDetails(
          localStorage.getItem("bi_id"),
          localStorage.getItem("product_id")
        )
      );
      dispatch(
        getBiFGoalStatus(
          localStorage.getItem("bi_id"),
          localStorage.getItem("product_id"),
          localStorage.getItem("functional_goal_id"),
          localStorage.getItem("goal_review_id")
        )
      );
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1048) {
        setCardsPerPage(2); // For small screens and tablets
      } else {
        setCardsPerPage(4); // For desktop
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize(); // Initial setup based on screen width
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const totalPages = Math.ceil(functionList.length / cardsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };
  const handleSelectFunction = (e) => {
    localStorage.setItem("function_id", e.value);
    localStorage.setItem("function_value", e.label);
    setSelectedFunction(e);
  };

  const startIndex = (currentPage - 1) * cardsPerPage;
  const endIndex = startIndex + cardsPerPage;

  useEffect(() => {
    if (getInitTrackerDetails) {
      setObjectiveList(getInitTrackerDetails.obj_data);
      setGoalList(getInitTrackerDetails.goal_data);
      const removedGEMSFunctionalGoals =
        getInitTrackerDetails.intiative_data.map((item) => ({
          ...item,
          strategic_imperative: item.strategic_imperative.filter(
            (task) => task.is_system_generated_task === false
          ),
        }));
      setFunctionList(removedGEMSFunctionalGoals);
    }
  }, [getInitTrackerDetails]);
  useEffect(() => {
    if (objectiveList) {
      const data = objectiveList.map((item) => {
        setMomentumScore(item.momentum_score);
      });
    }
  }, [objectiveList]);

  useEffect(() => {
    if (goalList.length === 1) {
      setSingleGoal(true);
    } else {
      setSingleGoal(false);
    }
  }, [goalList]);

  useEffect(() => {
    if (selectedBI) {
      setBIName(selectedBI.label);
    }
  }, [selectedBI]);

  const handleFunctionalGoalClick = (functional_goal_id) => {
    localStorage.setItem("functional_goal_id", functional_goal_id);
    dispatch(
      getFunctionalGoalReviewMeetingData(
        functional_goal_id,
        localStorage.getItem("bi_id")
      )
    );
    setShowMeetingPopup(true);
    // navigate("/executionplan");
  };

  const handleCloseMeetingPopup = () => {
    setShowMeetingPopup(false);
  };

  const handleClick = () => {
    navigate("/dashboard");
  };
  const handleBack = () => {
    navigate("/workboard");
  };
  const getColorClass = (progress) => {
    if (progress <= 33) {
      return "red";
    } else if (progress <= 66) {
      return "orange";
    } else {
      return "green";
    }
  };

  const [aiMeetingSummary, setAiMeetingSummary] = useState([]);
  const [meetingDetails, setMeetingDetails] = useState({});
  const [meetingFnFg, setmeetingFnFg] = useState({});

  useEffect(() => {
      if (fetchgetChatbot && fetchgetChatbot?.status == 200) {
        if (fetchgetChatbot.message === "chatbot not enabled") {
          setAiButtonEnabled(false);
        } else {
          setAiButtonEnabled(true);
        }
      }
    }, [fetchgetChatbot]);

  useEffect(() => {
      if (aiMeetingInsights){
        setmeetingFnFg(aiMeetingInsights?.fn_and_fg)
        setMeetingDetails(aiMeetingInsights?.meeting_details);
        setAiMeetingSummary(aiMeetingInsights?.summary);
      }
    }, [aiMeetingInsights]);

  

  const handleAiSummary = (imperative_id) => {

      setShowSummary(true);
      
      const bi_id = localStorage.getItem("bi_id");
      const product_id = localStorage.getItem("product_id");
      
      if (bi_id && product_id) {
      
          dispatch(getAiMeetingInsights(bi_id, product_id, imperative_id));
        
            }
  };

  const handleCloseSummary = () =>{

    setShowSummary(false); 
    
    setTimeout(() => {
      setAiMeetingSummary([]);
    }, 300);


  }



  const content = (
    <motion.div
      initial={{ y: "100%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: "easeInOut" }}
    >
      {showMeetingPopup && (
        <FunctionalGoalMeeting
          onClose={handleCloseMeetingPopup}
          selectedSubMenuPermission={selectedSubMenuPermission}
        />
      )}
      <Drawer
        sx={{
          "& .MuiDrawer-paper": {
            width: "50%",
            // padding: 2,
            height: "calc(100vh-63px)",
            marginTop: "64px",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "transparent",
            },
          },
        }}
        PaperProps={{
          sx: {
            boxShadow: "none",
            borderLeft: "1px solid lightGray",
          },
        }}
        anchor="right"
        transitionDuration={{ enter: 500, exit: 300 }}
        SlideProps={{
          easing: {
            enter: "cubic-bezier(0.0, 0, 0.2, 1)", // standard
            exit: "cubic-bezier(0.4, 0.0, 1, 1)", // ease-out
          },
        }}
        open={showSummary}
        onClose={handleCloseSummary}
      >
        <div
            style={{
              width: "100%",
              height:'60px',
              display:'flex',
              justifyContent:'space-between',
              alignItems:'center',
              // position: "relative",
              padding:'20px',
              borderBottom: "1px solid lightGray",
            }}
          >
            <div style={{fontWeight:'var(--heading-font-weight)'}} > <span className="ai-summary-button-icon" style={{marginRight:'10px'}} >
                                          <svg width="0" height="0">
                                            <defs>
                                              <linearGradient id="aiIconGradient" gradientTransform="rotate(90)">
                                                <stop offset="0%" stopColor="#A47CF3" />
                                                <stop offset="100%" stopColor="#683FEA" />
                                              </linearGradient>
                                            </defs>
                                          </svg>
                                          <HiSparkles size={24} />
                                        </span> Latest Meeting Insights</div>
            <div>
              <button
                style={{
                  border: "none",
                  background:'none',
                  fontSize:'36px'
                }}
                onClick={handleCloseSummary}
              >
                &times;
              </button>
            </div>
          </div>
          {!aiMeetingSummary.length ?
          <div
            style={{
              padding: "20px",
              width: "50vw",
              display: "flex",
              // alignItems: "center",
              
            }}
          >
            <div className="ai-loader">
              <div className="line"></div>
              <div className="line"></div>
              <div className="line"></div>
              <div className="line short"></div>

              <div className="gap"></div>

              <div className="line"></div>
              <div className="line"></div>
              <div className="line"></div>
              <div className="line"></div>
            </div>
            
          </div> :
          <div style={{ padding: "20px", width: "100%", flexGrow: 1, overflowY: "auto" }}>
  
            {/* Meeting Title */}
            <div
              style={{
                fontSize: "26px",
                fontWeight: 600,
                marginBottom: "6px"
              }}
            >
              {meetingDetails?.fungoal_review_meeting?.[0]?.title}
            </div>

            {/* Metadata block */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                marginBottom: "16px"
              }}
            >

              {/* Function Name */}
              <div style={{ fontSize: "15px", color: "#374151" }}>
                <span style={{ color: "#6b7280", fontWeight: 500 }}>Function: </span>&nbsp;&nbsp;
                {meetingFnFg?.function_name}
              </div>

              {/* Functional Goal */}
              <div style={{ fontSize: "15px", color: "#374151" }}>
                <span style={{ color: "#6b7280", fontWeight: 500 }}>Functional Goal: </span>&nbsp;&nbsp;
                {meetingFnFg?.functional_goal}
              </div>

              {/* Review Period */}
              <div style={{ fontSize: "15px", color: "#374151" }}>
                <span style={{ color: "#6b7280", fontWeight: 500 }}>Review Period: </span>&nbsp;&nbsp;
                {meetingDetails?.fungoal_review_meeting?.[0]?.start_date}
                {" – "}
                {meetingDetails?.fungoal_review_meeting?.[0]?.end_date}
              </div>

            </div>

            {/* Summary - Full Width */}
            <div
              style={{
                marginTop: "18px",
                marginBottom:'100px',
                fontSize: "16px",
                lineHeight: "1.9",
                color: "#3a3a3a",
                width: "100%",
                backgroundColor:'#f8fcfb',
                border:'1px solid #e2f0e7',
                padding:'10px',
                borderRadius:'10px'
              }}
            >
              <motion.ul
                style={{ paddingLeft: "20px", margin: 0 }}
                initial="hidden"
                animate="visible"
                variants={{
                  hidden: {},
                  visible: {
                    transition: { staggerChildren: 0.15 }
                  }
                }}
              >
                <AnimatePresence mode="popLayout">
                  {aiMeetingSummary?.map((item, index) => (
                    <motion.li
                      key={item + index}
                      layout
                      variants={{
                        hidden: { opacity: 0, y: 0 },
                        visible: {opacity: 1,y: 0,transition: { duration: 0.45, ease: "easeIn" }}
                      }}
                      exit={{ opacity: 0, y: 0 }}
                      style={{ marginBottom: "6px" }}
                    >
                      {item}
                    </motion.li>
                  ))}
                </AnimatePresence>
              </motion.ul>
            </div>
          </div>
        } 
      </Drawer>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            paddingRight: "10px",
            fontSize: "var(--main-heading)",
            display: "flex",
            fontWeight: "var(--heading-font-weight)",
          }}
        >
          {biName}
        </div>
        <div style={{ fontSize: "var(--sub-heading-font-size)" }}>
          Overall Progress:
        </div>
        <div style={{ backgroundColor: "#80c7aa" }} className="momentum-score">
          {momentumScore}
          {"%"}
        </div>
      </div>
      <br />
      <div>
        {objectiveList.map((item, index) => (
          <>
            <div key={index}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  position: "relative",
                  paddingRight: "10px",
                }}
              >
                <div className="Objective" style={{ wordWrap: "break-word" }}>
                  <div
                    className="d-flex align-items-center"
                    style={{
                      paddingTop: "10px",
                      fontSize: "var(--sub-heading-font-size)",
                    }}
                  >
                    <img
                      alt="objective"
                      src={Objective}
                      width={"24px"}
                      style={{ marginLeft: "10px" }}
                    />
                    <span style={{ paddingLeft: "5px" }}>Objective</span>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div
                      className="ObjectiveData"
                      style={{
                        width: "100%",
                        paddingBottom: "10px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        wordWrap: "break-word",
                        textOverflow: "ellipsis",
                        transition: "text-overflow 0.3s",
                        fontSize: "var(--text-font-size)",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.width = "100%";
                        e.target.style.whiteSpace = "normal";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.width = "100%";
                        e.target.style.whiteSpace = "nowrap";
                      }}
                    >
                      {item.name}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {goalList && goalList.length > 0 && (
              <div
                style={{
                  marginTop: "10px",
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                }}
              >
                {goalList.map((item, index) => (
                  <div
                    key={item.id}
                    className="goal col-lg-3"
                    style={{ width: singleGoal ? "100%" : "49%" }}
                  >
                    <div
                      style={{
                        position: "relative",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ wordWrap: "break-word" }}>
                        <div
                          className="d-flex align-items-center"
                          style={{ paddingTop: "10px" }}
                        >
                          <img
                            alt="goal"
                            src={Goals}
                            width={"24px"}
                            style={{ marginLeft: "10px" }}
                          />
                          <span
                            style={{
                              paddingLeft: "5px",
                              fontSize: "var(--sub-heading-font-size)",
                            }}
                          >
                            Goal ({item.short_name})
                          </span>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <div
                          className="ObjectiveData"
                          style={{
                            width: "100%",
                            paddingBottom: "10px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            wordWrap: "break-word",
                            textOverflow: "ellipsis",
                            transition: "text-overflow 0.3s",
                            fontSize: "var(--text-font-size)",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.width = "100%";
                            e.target.style.whiteSpace = "normal";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.width = "100%";
                            e.target.style.whiteSpace = "nowrap";
                          }}
                        >
                          {item.name}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {functionList && functionList.length > 0 ? (
              <>
                <div className="pagination">
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    <span style={{ opacity: currentPage == 1 ? 0.3 : 1 }}>
                      <img alt="chevronleft" src={ChevronLeft} width={25} />
                    </span>
                  </button>
                  <span style={{ margin: "0px 5px" }}>
                    {currentPage} / {totalPages}
                  </span>
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    <span
                      style={{ opacity: currentPage == totalPages ? 0.3 : 1 }}
                    >
                      <img alt="chevronright" src={ChevronRight} width={25} />
                    </span>
                  </button>
                </div>
                <div className="card-container">
                  {functionList && functionList.length > 0 && (
                    <div className="rows">
                      {functionList
                        .slice(startIndex, endIndex)
                        .map((item, index) => (
                          <div key={item.id} className="card-wrapper">
                            <div className="cards">
                              <div className="card-body">
                                {/* logo */}
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>
                                    <img alt="icon" src={url + item.icon} />
                                  </div>
                                  {/*logo close  */}
                                  <div>
                                    <p className="card-title">{item.name}</p>

                                    {/* <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      marginTop: "5px",
                                      marginLeft: "5px",
                                    }}
                                  >
                                    <span style={{ fontSize: "11px" }}>
                                      MOMENTUM SCORE:
                                    </span>
                                    {item.momentum_score !== undefined ? (
                                      <span className="momentum-score">
                                        {item.momentum_score > 50 ? (
                                          <div>
                                            <span
                                              style={{
                                                color: "#0A5F59",
                                                fontSize: "12px",
                                              }}
                                            >
                                              {item.momentum_score}
                                            </span>
                                            <img
                                              alt="up"
                                              style={{ marginLeft: "10px" }}
                                              src={Up}
                                            />
                                          </div>
                                        ) : (
                                          <div>
                                            <span
                                              style={{
                                                color: "#EF2C2C",
                                                fontSize: "12px",
                                              }}
                                            >
                                              {item.momentum_score}
                                            </span>
                                            <img
                                              alt="down"
                                              style={{ marginLeft: "10px" }}
                                              src={Down}
                                            />
                                          </div>
                                        )}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </div> */}
                                  </div>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "end",
                                    alignItems:'center'

                                  }}
                                >
                                  <div>
                                    <div className="fn-progress">
                                      {item.progress}%
                                    </div>
                                  </div>
                                  <div>
                                    {item.assigned_to &&
                                    item.assigned_to.length > 0 &&
                                    item.assigned_to.find(
                                      (j) => j.is_active
                                    ) ? (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip
                                            id={`tooltip-${
                                              item.assigned_to.find(
                                                (j) => j.is_active
                                              ).label
                                            }`}
                                          >
                                            {
                                              item.assigned_to.find(
                                                (j) => j.is_active
                                              ).label
                                            }
                                          </Tooltip>
                                        }
                                      >
                                          <div style={{
                                            position: "relative",
                                            display: "inline-block",
                                            // margin: "10px",
                                          }}>
                                            <img
                                          style={{ margin: "10px" }}
                                          alt=""
                                          src={createImageFromInitials(
                                            30,
                                            item.assigned_to.find(
                                              (j) => j.is_active
                                            ).label,
                                            getRandomColor(
                                              item.assigned_to.find(
                                                (j) => j.is_active
                                              ).label
                                            )
                                          )}
                                        />
                                             {(item.assigned_to.find((item) => item.is_active)?.status ==="Inactive" ||item.assigned_to.find((item) => item.is_active)?.bi_mapping===false)&&(
                                              < TiDelete
                                                size={14}
                                                style={{
                                                  position: "absolute",
                                                  bottom: "10px",
                                                  right: "10px",
                                                  background: "#fff",
                                                  borderRadius: "50%",
                                                  color: "#DC2626",
                                                  padding: "1px",
                                                }}
                                              />
                                            )}
                                          </div>
                                        </OverlayTrigger>
                                    ) : (
                                      <img
                                        alt=""
                                        src={UserProfile}
                                        style={{ margin: "10px" }}
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                              <ProgressBar className="fn-progress-bar" variant="success" now={item.progress} />
                            </div>
                            {/* strategic imperative */}
                            {item.strategic_imperative.map((imperative) => (
                              <div
                                key={imperative.id}
                                className="strategic_card"
                              >
                                <div
                                  className="sub_strategic_card"
                                  onClick={(e) =>
                                    handleFunctionalGoalClick(imperative.id)
                                  }
                                >
                                  <div className="stratgic_card_title">
                                    {imperative.name}
                                  </div>
                                  <div>
                                    {imperative.assigned_to.length > 0 &&
                                    imperative.assigned_to.find(
                                      (item) => item.is_active
                                    ) ? (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip
                                            id={`tooltip-${
                                              imperative.assigned_to.find(
                                                (item) => item.is_active
                                              ).label
                                            }`}
                                          >
                                            {
                                              imperative.assigned_to.find(
                                                (item) => item.is_active
                                              ).label
                                            }
                                          </Tooltip>
                                        }
                                      >
                                          <div style={{
                                            position: "relative",
                                            display: "inline-block",
                                            // margin: "10px",
                                          }}>
                                            <img
                                          style={{ margin: "10px" }}
                                          alt="owner"
                                          src={createImageFromInitials(
                                            30,
                                            imperative.assigned_to.find(
                                              (item) => item.is_active
                                            ).label,
                                            getRandomColor(
                                              imperative.assigned_to.find(
                                                (item) => item.is_active
                                              ).label
                                            )
                                          )}
                                        />
                                             {(imperative.assigned_to.find((item) => item.is_active)?.status ===
                                              "Inactive" ||imperative.assigned_to.find((item) => item.is_active)?.bi_mapping===false)&&(
                                              < TiDelete
                                                size={14}
                                                style={{
                                                  position: "absolute",
                                                  bottom: "10px",
                                                  right: "10px",
                                                  background: "#fff",
                                                  borderRadius: "50%",
                                                  color: "#DC2626",
                                                  padding: "1px",
                                                }}
                                              />
                                            )}  

                                          </div>
                                      </OverlayTrigger>
                                    ) : (
                                      <img
                                        alt="userprofile"
                                        src={UserProfile}
                                        style={{ margin: "10px" }}
                                      />
                                    )}
                                  </div>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: 'wrap',
                                    justifyContent:'space-between',
                                    textTransform: "uppercase",
                                    rowGap: '10px'
                                  }}
                                >
                                  <div style={{display:'flex', flexDirection:'row'}} >
                                    <div>
                                      {imperative.status_name &&
                                        createStatus(imperative.status_name)}
                                    </div>

                                    {aiButtonEnabled &&
                                      <div>
                                      <button
                                        className="ai-summary-button"
                                        type="button"
                                        // onClick={() => setSimpModel(functionIndex, false)}
                                        onClick={()=> handleAiSummary(imperative.id)}
                                      >
                                        {/* <img
                                          src={ChatIcon}
                                          width={40}
                                          height={40}
                                          style={{ marginTop:'3px' }}
                                        /> */}
                                        <span className="ai-summary-button-icon" >
                                          <svg width="0" height="0">
                                            <defs>
                                              <linearGradient id="aiIconGradient" gradientTransform="rotate(90)">
                                                <stop offset="0%" stopColor="#A47CF3" />
                                                <stop offset="100%" stopColor="#683FEA" />
                                              </linearGradient>
                                            </defs>
                                          </svg>
                                          <HiSparkles size={16}/>
                                        </span>
                                        
                                        <span className="ai-summary-button-text" >AI Insights</span>
                                        
                                        </button>
                                      </div>}
                                    </div>
                                  
                                  <div>
                                    <div className="fg-progress" style={{marginRight:'10px'}} >
                                      {imperative.fg_progress}%
                                    </div>
                                  </div>

                                  {/* <div
                                    className="selected-goal"
                                    style={{
                                      display: "flex",
                                      marginRight: "15px",
                                      alignItems: "center",
                                      fontSize: "var(--sub-heading-font-size)",
                                    }}
                                  >
                                    {imperative.goals_dt &&
                                      imperative.goals_dt.map(
                                        (goal, index) =>
                                          goal.is_active && (
                                            <div
                                              key={index}
                                              style={{
                                                paddingLeft: "5px",
                                                fontSize:
                                                  "var(--sub-heading-font-size)",
                                              }}
                                            >
                                              {goal.short_name}
                                            </div>
                                          )
                                      )}
                                    <span style={{ paddingLeft: "5px" }}>
                                      <BiChevronDown />
                                    </span>
                                  </div> */}
                                </div>

                                {/* <div>
                                  {createProgressBar(imperative.status_name)}
                                </div> */}
                              </div>
                            ))}
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              </>
            ) : (
              <p>There are no functions mapped.</p>
            )}
          </>
        ))}
      </div>
      <div>
        <CommentSection />
        {selectedHelpInfoSidebar && <SideNavHelpInfo />}
      </div>
    </motion.div>
  );
  if (!localStorage.getItem("authenticated")) {
    return (
      <div>
        <Login />
      </div>
    );
  } else {
    return (
      <>
        <MainComponent
          maincontent={content}
          // showTemplate={true}
          showSelector={true}
          showProducts={true}
          showButtons={true}
          handleNext={handleClick}
          handleBackButton={handleBack}
          breadcrumbParent={"GTM Execution"}
          breadcrumbChild={"Initiative Tracker"}
          documentName={"Initiative Tracker"}
          helpKey={keys["Initiative Tracker"].Name}
          image={"question"}
        />
      </>
    );
  }
}

export default InitiativeTracker;
